import React from "react";
import { CSVLink } from "react-csv";
import export2excel from "../../assets/images/export2excel.svg";
import { changeDateFormat } from "../../utils";
import { formatDate } from "../Projects/ProjectPlan/util";
import { isString } from "lodash";

export const ExportSelectedRows = ({ allData, selectedRows, headers, filename}) => {
  // Helper function to format data rows
  const formatData = (data) => {
    const formattedData = {
      ...data,
    };
    if (data) {
      formattedData.Start_Date = !isString(data?.Start_Date) ? formatDate(data?.Start_Date) : data?.Start_Date;
      formattedData.End_Date = !isString(data?.End_Date) ? formatDate(data?.End_Date) : data?.End_Date;

      if (
        data["Estimated_SOP"] !== undefined ||
        data["Estimated_SOS"] !== undefined ||
        data["Estimated_AW_Printer"] !== undefined ||
        data["Estimated_AW_Readiness"] !== undefined
      ) {
        formattedData.Estimated_SOP = changeDateFormat(data["Estimated_SOP"]);
        formattedData.Estimated_SOS = changeDateFormat(data["Estimated_SOS"]);
        formattedData.Category = filename === "Materials_Records" ?  data["Category"] : data["Artwork_Category"];
        formattedData.Brand = data["Artwork_Brand"];
        formattedData.SMO = data["Artwork_SMO"];
        formattedData.region = data["Project_region"];
        formattedData.Scale = data["Project_Scale"];
      } else if (data["Assignee"] !== undefined) {
        formattedData.Owner = data["Assignee"];
      }
    }

    return formattedData;
  };

  // --- Robust header extraction and mapping ---
  // Accepts headers as array of {label, key} or strings
  const headerKeys = headers?.map(h => (typeof h === 'object' && h !== null ? h.key : h));
  const headerLabels = headers?.map(h => (typeof h === 'object' && h !== null ? h.label : h));

  // Optionally transform header labels for display
  const modifiedHeaderLabels = headerLabels?.map(label => {
    if (typeof label === 'string' && label.startsWith('Project_Scale')) {
      return label.substring(8);
    } else if (typeof label === 'string' && label.startsWith('Project_region')) {
      return 'Region';
    } else if (typeof label === 'string' && label.startsWith('Artwork_Status')) {
      return 'Artwork Status';
    }
    return label;
  });

  // Only export columns in headerKeys order
  const filterDataByHeaders = (dataArr) => {
    return dataArr.map(row => {
      const filtered = {};
      headerKeys?.forEach((key, idx) => {
        filtered[modifiedHeaderLabels[idx]] = row[key];
      });
      return filtered;
    });
  };

  const formattedAllData = allData ? filterDataByHeaders(allData.map(formatData)) : [];
  const formattedSelectedRows = selectedRows ? filterDataByHeaders(selectedRows.map(formatData)) : [];

  const generateCsvReport = (data, headers, fileName) => ({
    data,
    headers: headers,
    filename: fileName
  });

  if (!selectedRows || selectedRows.length === 0) {
    if (allData !== null && allData !== undefined) {
      const csvReport = generateCsvReport(
        formattedAllData,
        modifiedHeaderLabels,
        filename ? `${filename}.csv` : "Project_Records.csv"
      );
      return <>{csvTag(csvReport)}</>;
    }
  } else if (selectedRows.length > 0) {
    // Always use the provided filename as-is for export
    const exportFileName = filename === "ChangeHandling_History"
      ? "ChangeHandling_History_Records.csv"
      : `${filename}_Selected_Rows.csv`;
    const csvReport = generateCsvReport(
      formattedSelectedRows,
      modifiedHeaderLabels,
      exportFileName
    );
    return <>{csvTag(csvReport)}</>;
  }

  return null;
};

const csvTag = (data) => {
  return (
    <CSVLink {...data}>
      <img src={export2excel} alt="Export to csv"/>
    </CSVLink>
  );
};

export default ExportSelectedRows;
